import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "Login",
    component: () => import('../views/Login.vue'),
  },
  {
    path: "/measurements",
    name: "measurements",
    component: () => import('../views/Measurements.vue'),
  },
  {
    path: "/diaries",
    name: "diaries",
    component: () => import('../views/Diaries.vue'),
  },
  {
    path: "/call",
    name: "call",
    component: () => import('../views/VideoCall.vue'),
  },
  {
    path: "/",
    name: "dashboard",
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: "/patient",
    name: "patient",
    component: () => import('../views/PatientSheet.vue')
  },
  {
    path: "/manual",
    name: "manual",
    component: () => import('../views/Manual.vue')
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import('../views/Faq.vue')
  },
	{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
